// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2otSh","title":"Header_title__3mIRm","main-image":"Header_main-image__YJkAJ"};